/**
 * @param {ApiAddressPreview} data
 * @returns {AddressPreview}
 */
export const parseAddressPreview = (data) => ({
  id: data.id,
  description: data.description,
  street: data.street,
  streetNumber: data.streetNumber,
  streetDetails: data.complementary,
  neighborhood: data.neighborhood,
  zipcode: data.zipcode,
  addressType: data.addressType,
  addressTypeFormat: data.addressTypeFormat,
  state: data.state,
  city: data.city,
})

/**
 * @param {ApiAddressList} data
 * @returns {Array.<AddressPreview>}
 */
export const parseAddressList = (data) => {
  return data.items.map(parseAddressPreview)
}

/**
 * @param {ApiAddressDetails} data
 * @returns {AddressUpdate}
 */
export const parseAddressUpdate = (data) => ({
  id: data.id,
  description: data.description,
  zipcode: data.zipcode,
  cityId: data.cityId,
  stateId: data.stateId,
  neighborhood: data.neighborhood,
  street: data.street,
  streetNumber: data.streetNumber,
  streetDetails: data.complementary,
  addressType: data.addressType,
  isMain: data.isMain || false,
})

export default {
  parseAddressPreview,
  parseAddressList,
}